import { AdminApi } from "../../core/api/AdminApi";
import { HeartbeatResponse } from "../models/HeartbeatResponse";

const HeartbeatApi = AdminApi.injectEndpoints({
  endpoints: (builder) => ({
    getHeartbeat: builder.query<HeartbeatResponse, void>({
      query: () => {
        return {
          url: "heartbeat",
          method: "GET"
        };
      }
    })
  })
});

export const {
  useGetHeartbeatQuery
} = HeartbeatApi;